import Contact from "../presentation/views/Contact.vue";
import ContactDetail from "../presentation/views/ContactDetail.vue";
/**
 * UUID matcher for the `:id` route param. A non-UUID path falls through to the
 * shell NotFound catch-all instead of mounting the detail page with a bad id.
 */
const UUID_PARAM = "[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}";
/**
 * Contact Module Routes and Navigation
 *
 * This file contains all route definitions and navigation items for the Contact Module.
 * Both routes and navigation items are exported and used by the ContactModule class.
 */
export const contactRoutes = [
    {
        path: "/contacts",
        name: "Contact",
        component: Contact,
        meta: { requiresAuth: true, titleKey: "contact.title" },
    },
    {
        path: `/contacts/:id(${UUID_PARAM})`,
        name: "ContactDetail",
        component: ContactDetail,
        // Authorization is enforced server-side (OPHUB read policy via the BFF);
        // the frontend does not gate this route on a role.
        meta: { requiresAuth: true, titleKey: "contact.title" },
    },
];
export const contactNavigationItems = [
    {
        labelKey: "contact.title",
        children: [
            {
                labelKey: "contact.title",
                path: "/contacts",
                meta: { requiresAuth: true },
            },
        ],
    },
];
